import { render } from "./BreadcrumbLink.vue?vue&type=template&id=ecba7b70"
import script from "./BreadcrumbLink.vue?vue&type=script&lang=js"
export * from "./BreadcrumbLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__